/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Modal_DescriptionInputs */

const he_auth_modal_description = /** @type {(inputs: Auth_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יש צורך בהתחברות כדי לבצע פעולה זו.`)
};

const en_auth_modal_description = /** @type {(inputs: Auth_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication is required for this action.`)
};

/**
* | output |
* | --- |
* | "Authentication is required for this action." |
*
* @param {Auth_Modal_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_modal_description = /** @type {((inputs?: Auth_Modal_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Modal_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_modal_description(inputs)
	return en_auth_modal_description(inputs)
});